import { useMemo } from 'react';

import { useCatalog } from '@hooks/useCatalog';
import { getAvailableTimezones } from '@modules/utils/getAvailableTimezones';

export const useAvailableTimezones = (): string[] => {
  const { timeZoneOptions } = useCatalog();

  return useMemo(
    () => getAvailableTimezones(timeZoneOptions),
    [timeZoneOptions]
  );
};
